import { Database, Migrator } from '../../db/index.js'
import migrations from './migrations/index.js'
import type { DatabaseSchema } from './schema/index.js'
export * from './schema/index.js'

export type ActorDb = Database<DatabaseSchema>

export const getDb = (
  location: string,
  disableWalAutoCheckpoint = false,
): ActorDb => {
  const pragmas: Record<string, string> = disableWalAutoCheckpoint
    ? { wal_autocheckpoint: '0' }
    : {}
  return Database.sqlite(location, { pragmas })
}

export const getMigrator = (db: Database<DatabaseSchema>) => {
  return new Migrator(db.db, migrations)
}
